import {Component} from '@angular/core';
import {IonicPage} from 'ionic-angular';

import * as Config from '../../app/app.config';

/**
 * Generated class for the HelpPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-help',
  templateUrl: 'help.html',
})
export class HelpPage {

  version: string = Config.version;

  ionViewDidLoad() {
    console.log('ionViewDidLoad HelpPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/help/help.ts